/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Edit_QuestionInputs */

const en_admin_questionnaire_editor_edit_question = /** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Question`)
};

const nl_admin_questionnaire_editor_edit_question = /** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vraag bewerken`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */
const de_admin_questionnaire_editor_edit_question = en_admin_questionnaire_editor_edit_question;

/** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */
const es_admin_questionnaire_editor_edit_question = en_admin_questionnaire_editor_edit_question;

/** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_edit_question = en_admin_questionnaire_editor_edit_question;

/** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */
const it_admin_questionnaire_editor_edit_question = en_admin_questionnaire_editor_edit_question;

/** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_edit_question = en_admin_questionnaire_editor_edit_question;

/** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_edit_question = en_admin_questionnaire_editor_edit_question;

/** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_edit_question = en_admin_questionnaire_editor_edit_question;

/** @type {(inputs: Admin_Questionnaire_Editor_Edit_QuestionInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_edit_question = en_admin_questionnaire_editor_edit_question;

/**
* | output |
* | --- |
* | "Edit Question" |
*
* @param {Admin_Questionnaire_Editor_Edit_QuestionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_edit_question = /** @type {((inputs?: Admin_Questionnaire_Editor_Edit_QuestionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Edit_QuestionInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_edit_question(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_edit_question(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_edit_question(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_edit_question(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_edit_question(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_edit_question(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_edit_question(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_edit_question(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_edit_question(inputs)
	return ro_admin_questionnaire_editor_edit_question(inputs)
});
export { admin_questionnaire_editor_edit_question as "admin.questionnaire_editor.edit_question" }